module.exports = __webpack_public_path__ + "static-portal/img/8.0117c41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/8.jpg
// module id = zofi
// module chunks = 4